import DeleteMeetingForwardNotificationOption from './DeleteMeetingForwardNotificationOption';
import DeleteOldMeetingMessageOption from './DeleteOldMeetingMessageOption';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';

/**
 * Stateless functional component to render invitation options in settings.
 */

export default observer(function InvitationFull() {
    return (
        <div>
            <OptionDescription>{strings.options_invitation_description}</OptionDescription>
            <DeleteOldMeetingMessageOption />
            <DeleteMeetingForwardNotificationOption />
        </div>
    );
});
